import { render, staticRenderFns } from "./DetailNotificationPage.vue?vue&type=template&id=4c3576e0&scoped=true"
import script from "./DetailNotificationPage.vue?vue&type=script&lang=js"
export * from "./DetailNotificationPage.vue?vue&type=script&lang=js"
import style0 from "./DetailNotificationPage.vue?vue&type=style&index=0&id=4c3576e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3576e0",
  null
  
)

export default component.exports